
import { Component, Vue, Prop } from "vue-property-decorator";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import request from "@/lib/request/request";
import mp3List from "@/lib/common/mp3";
import HinaSwitch from "../baseComponent/hina-switch.vue";
import HinaTextarea from "../baseComponent/hina-textarea.vue";
import HinaSelect from "../baseComponent/hina-select.vue";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import { EnumQuestionType } from "@/lib/model/exambuilder/question-v2";

interface QuestionnaireTemplate {
  questionnaireId: number;
  name: string;
}

interface TestExam {
  testExamId: number;
  name: string;
}

@Component({
  components: {
    InputNumberV3,
    HinaRadioGroup,
    HinaSwitch,
    HinaSelect,
    HinaTextarea
  }
})
export default class AiAsk extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: false }) setWeb!: boolean; //内部使用 web配置

  // 调查问卷
  questionnaireTemplateList: QuestionnaireTemplate[] = [];

  get canUseReadingDetecting() {
    const isRandom = this.formItemData.questions.isRandomQuestion;
    return isRandom
      ? !!this.formItemData.questions.randomConfigList.find(
          item => item.questionType === EnumQuestionType.EnumQuestionTypeVideo
        )
      : !!this.formItemData.questions.questionConfigList.find(
          item => item.questionType === EnumQuestionType.EnumQuestionTypeVideo
        );
  }

  async getQuestionnaireTemplate() {
    const res = await request.postInterviewApi(
      "hr/company/questionnaireTemplate"
    );
    this.questionnaireTemplateList = res.data.data.testExamList;
    if (
      this.formItemData.questionnaireConfig.configData.questionnaireId === 0
    ) {
      this.formItemData.questionnaireConfig.configData.questionnaireId =
        this.questionnaireTemplateList[0]?.questionnaireId || 0;
    }
  }

  // 模拟练习
  testExamList: TestExam[] = [];

  async getTestExam() {
    const res = await request.postInterviewApi("hr/company/testExams");
    this.testExamList = res.data.data.testExamList;

    if (this.formItemData.testExamConfig.configData.testExamId === 0) {
      this.formItemData.testExamConfig.configData.testExamId =
        this.testExamList[0]?.testExamId || 0;
    }
  }

  // 虚拟人音色驱动
  get voiceDrive() {
    return this.formItemData.virConfig.voiceType === "" ? 0 : 1;
  }
  set voiceDrive(v: number) {
    this.formItemData.virConfig.voiceType =
      v === 0 ? "" : this.voiceTypeOption[0]?.id || "";
  }

  voiceDriveOption = [
    { name: "文本驱动", value: 0 },
    { name: "音频驱动", value: 1 }
  ];

  get voiceTypeOption() {
    return mp3List.map(item => ({
      ...item,
      name: item.name,
      value: item.id
    }));
  }

  // 题目乱序
  get maxQuestionNum() {
    // 如果是抽题，返回抽题组中的几抽几randomConfigList数组中 questionNumber 的数量的累加
    if (this.formItemData.questions.isRandomQuestion === 1) {
      return this.formItemData.questions.randomConfigList.reduce(
        (pre, cur) => pre + cur.questionNumber,
        0
      );
    }
    return this.formItemData.questionSelectedList.length;
  }

  get questionConfig() {
    return this.formItemData.questions.configData;
  }

  // 导出加密
  get encodeConfig() {
    return this.formItemData.reportConfig.encodeConfig;
  }

  get needEncrypt() {
    return !!(
      this.encodeConfig.encodeTypeConnectCode ||
      this.encodeConfig.encodeTypeBaseInfo ||
      this.encodeConfig.encodeTypeOtherInfo
    );
  }

  baseEncodeTypeOption = [
    { name: "展示", value: 0 },
    { name: "不展示", value: 1 },
    { name: "加密展示", value: 2 }
  ];

  mounted() {
    this.getQuestionnaireTemplate();
    this.getTestExam();
  }

  // 校验表单数据
  validate() {
    // 题目乱序校验, 题目乱序开启 且 总题数小于题目乱序questionRandomSortRange数组中的数量时，提示错误信息
    if (this.questionConfig.questionRandomSort === 1) {
      if (
        this.maxQuestionNum <
          this.questionConfig.questionRandomSortRange?.[0] ||
        this.maxQuestionNum < this.questionConfig.questionRandomSortRange?.[1]
      ) {
        this.$message.error(
          `总共有${this.maxQuestionNum}道题，题目乱序的配置大于总题数，请重新设置！`
        );
        return false;
      } else if (
        this.questionConfig.questionRandomSortRange?.[0] >
        this.questionConfig.questionRandomSortRange?.[1]
      ) {
        this.$message.error(
          `题目乱序现在配置的是第${this.questionConfig.questionRandomSortRange?.[0]}题到第${this.questionConfig.questionRandomSortRange?.[1]}题乱序。应该配置为第${this.questionConfig.questionRandomSortRange?.[1]}题到第${this.questionConfig.questionRandomSortRange?.[0]}题乱序，请重新设置！`
        );
        return false;
      }
    }

    return true;
  }

  // 校验数据
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = this.validate();
      if (valid) {
        resolve("");
      } else {
        resolve("otherSet");
      }
    });
  }

  handlePlay(idx: string) {
    document.querySelectorAll(".mini-mp3").forEach((item, i) => {
      if (idx === i) return;
      (item as HTMLAudioElement).pause();
    });
  }
}
